import React from "react";

export default function ExamProcessInfographic() {
  const steps = [
    {
      number: "01",
      title: "Post Final Briefing, Movement of Exam Executives",
      color: "#17a2b8",
      icon: "📋",
    },
    {
      number: "02",
      title: "Handling Lodging and Movement to Exam Sites",
      color: "#72cddb",
      icon: "🏢",
    },
    {
      number: "03",
      title: "Secured Movement of Hardware and Exam Kit to/ from Sites",
      color: "#8bc34a",
      icon: "💡",
    },
    {
      number: "04",
      title: "Support in Local Police arrangement at Exam Site",
      color: "#78c97b",
      icon: "👮",
    },
    {
      number: "05",
      title: "Readiness check of Exam Site minimum 3 days prior to Exam",
      color: "#3d9996",
      icon: "📊",
    },
    {
      number: "06",
      title: "Audit Report and Exam Preparedness Check List",
      color: "#793d99",
      icon: "📈",
    },
    {
      number: "07",
      title: "Explicit Care to Power Backup, IT Infra, CCTV, Network, Phones & Wi-Fi",
      color: "#afad4c",
      icon: "📱",
    },
    {
      number: "08",
      title: "Explicit Care of Network (Extra wire and devices) and premises security",
      color: "#8bc34a",
      icon: "🖥",
    },
    {
      number: "09",
      title: "Centre Authorized Manpower Verification, all superfluous restricted",
      color: "#2b3b3e",
      icon: "💡",
    },
    {
      number: "10",
      title: "Two Days full Mock Drill of Exam at the actual site",
      color: "#6f716b",
      icon: "📊",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "Segoe UI, sans-serif",
        padding: "2rem 1rem",
        marginBottom:"30px",
        backgroundColor: "#f8f9fa",
        marginTop:"70px"
      }}
    >
      <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
        <h3
          style={{
            fontWeight: "800",
            letterSpacing: "1px",
            textAlign: "center",
            marginBottom: "5rem",
            lineHeight: "1.3",
            fontSize: "clamp(1.5rem, 5vw, 3.2rem)"
          }}
          className="title split-collab text-danger"
        >
          EXAMINATION PROCESS MANAGEMENT 1
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.8rem",
            padding: "0 2rem"
          }}
           data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800"
        >
          {steps.map((step, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#dc3545",
                borderRadius: "12px",
                padding: "1.5rem",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                cursor: "pointer",
                minHeight: "120px"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  fontSize: "clamp(2rem, 3vw, 2rem)",
                  fontWeight: "bold",
                  color: "white",
                  flexShrink: 0
                }}
              >
                {step.number}
              </div>
              
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: "clamp(1.4rem, 2vw, 1rem)",
                    color: "white",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    wordWrap: "break-word"
                  }}
                >
                  {step.title}
                </div>
              </div>
              
              <div
                style={{
                  width: "clamp(50px, 8vw, 60px)",
                  height: "clamp(50px, 8vw, 60px)",
                  borderRadius: "50%",
                  backgroundColor: step.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  position: "relative",
                  border: "3px solid rgba(255, 255, 255, 0.3)"
                }}
              >
                <div
                  style={{
                    width: "clamp(25px, 5vw, 30px)",
                    height: "clamp(25px, 5vw, 30px)",
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "clamp(0.8rem, 2vw, 1rem)"
                  }}
                >
                  {step.icon}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}